(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["able-react"] = factory();
	else
		root["able-react"] = factory();
})(this, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 6942:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 9625:
/***/ (() => {



/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ src_PageStepper)
});

;// external "@babel/runtime/helpers/slicedToArray"
const slicedToArray_namespaceObject = require("@babel/runtime/helpers/slicedToArray");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray_namespaceObject);
;// external "react"
const external_react_namespaceObject = require("react");
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(6942);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// external "uuid"
const external_uuid_namespaceObject = require("uuid");
;// external "react/jsx-runtime"
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
;// ./src/PageStepper/PageStepper.tsx





/**
 * A Page Stepper, also known as Progress Stepper / Tracker, is a visual representation of a users progress through a set of steps, guiding towards the completion of a specified process.
 *  It is a digital way-finding tool that supports multi page form flows.
 * [View the Page Stepper pattern documentation on Confluence](https://confluence.tools.telstra.com/display/DCSYS/Page+Stepper)
 *
 * @version 1.0.0
 */

function PageStepper(props) {
  var className = props.className,
    pageTitle = props.pageTitle,
    pageTagline = props.pageTagline,
    variant = props.variant,
    numberOfSteps = props.numberOfSteps,
    currentStep = props.currentStep,
    percentageComplete = props.percentageComplete,
    _props$removeTopSpaci = props.removeTopSpacing,
    removeTopSpacing = _props$removeTopSpaci === void 0 ? true : _props$removeTopSpaci,
    _props$removeBottomSp = props.removeBottomSpacingAndDivider,
    removeBottomSpacingAndDivider = _props$removeBottomSp === void 0 ? true : _props$removeBottomSp,
    useTenColumnGrid = props.useTenColumnGrid,
    headingRef = props.headingRef,
    _props$limitTextWidth = props.limitTextWidthToFiftyPercent,
    limitTextWidthToFiftyPercent = _props$limitTextWidth === void 0 ? false : _props$limitTextWidth;
  var pageStepperRef = (0,external_react_namespaceObject.useRef)();
  var _useState = (0,external_react_namespaceObject.useState)(variant),
    _useState2 = slicedToArray_default()(_useState, 2),
    currentVariant = _useState2[0],
    setCurrentVariant = _useState2[1];
  var maxNumberOfStepsWhenFixed = 8;
  (0,external_react_namespaceObject.useEffect)(function () {
    if (numberOfSteps && variant === 'Fixed') {
      if (numberOfSteps > maxNumberOfStepsWhenFixed) {
        console.error('ABLE ERROR: If you have more than 8 steps you need to use the Fluid variant with the percentageComplete prop');
        setCurrentVariant('Fluid');
      }
      if (pageStepperRef.current) {
        pageStepperRef.current.style.setProperty('--able-pageStepper-noOfSteps', numberOfSteps.toString(10));
      }
    }
  }, [numberOfSteps]);
  var classes = classnames_default()(className || undefined);
  var stepDots = function stepDots() {
    var totalDotsToOutput = numberOfSteps && numberOfSteps <= maxNumberOfStepsWhenFixed ? numberOfSteps + 1 : 2;
    var DotsToOutput = [];
    for (var i = 0; i < totalDotsToOutput; i += 1) {
      DotsToOutput.push(/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("span", {}, "pageStepperDot".concat((0,external_uuid_namespaceObject.v4)())));
    }
    return DotsToOutput;
  };
  var validCurrentStep = function validCurrentStep() {
    if (typeof currentStep === 'number' && numberOfSteps) {
      if (currentStep < 1) {
        return 1;
      } else if (currentStep <= numberOfSteps) {
        return currentStep;
      } else if (currentStep > numberOfSteps) {
        return numberOfSteps;
      }
    }
    return undefined;
  };
  var validPercentage = function validPercentage() {
    if (typeof percentageComplete === 'number') {
      if (percentageComplete < 1) {
        return 1;
      } else if (percentageComplete > 100) {
        return 100;
      } else {
        return Math.round(percentageComplete);
      }
    }
    return undefined;
  };
  var configureDefaultClass = function configureDefaultClass() {
    var defaultClass = 'able-PageStepper';
    if (removeTopSpacing) {
      defaultClass += '--no-top-spacing';
    }
    if (removeBottomSpacingAndDivider) {
      defaultClass += '--no-bottom-spacing';
    }
    if (useTenColumnGrid) {
      defaultClass += '--ten-col-grid';
    }
    if (limitTextWidthToFiftyPercent) {
      defaultClass += ' able-PageStepper--limit-text-width';
      if (useTenColumnGrid) {
        defaultClass += '--ten-col-grid';
      }
    }
    return defaultClass;
  };
  var currentStepId = (0,external_react_namespaceObject.useId)();
  var generatedCurrentStepId = "currentPageStep-".concat(currentStepId);
  var Heading = function Heading() {
    return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("h1", {
      "aria-describedby": generatedCurrentStepId,
      ref: headingRef,
      tabIndex: headingRef ? -1 : undefined,
      children: pageTitle
    });
  };
  var HeadingGroup = function HeadingGroup() {
    return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("hgroup", {
      role: "group",
      "aria-roledescription": "Heading group",
      children: [/*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(Heading, {}), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("p", {
        children: pageTagline
      })]
    });
  };
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
    ref: pageStepperRef,
    className: "".concat(configureDefaultClass(), " able-PageStepper--").concat(currentVariant, " ").concat(validCurrentStep() && numberOfSteps ? "current-step-".concat(validCurrentStep()) : '', " ").concat(classes),
    children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
          children: [currentVariant === 'Fixed' && numberOfSteps && validCurrentStep() ? /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("p", {
            id: generatedCurrentStepId,
            children: "Step ".concat(validCurrentStep(), " of ").concat(numberOfSteps)
          }) : null, currentVariant === 'Fluid' && validPercentage() ? /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("p", {
            id: generatedCurrentStepId,
            children: "".concat(validPercentage(), "% Complete")
          }) : null, /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
              children: [stepDots(), currentVariant === 'Fixed' ? /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("span", {
                className: "bar-complete"
              }) : null, currentVariant === 'Fluid' && validPercentage() ? /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("span", {
                className: "bar-complete",
                style: {
                  width: "".concat(validPercentage(), "%")
                }
              }) : null]
            })
          }), pageTagline ? /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(HeadingGroup, {}) : /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(Heading, {})]
        })
      })
    })
  });
}
/* harmony default export */ const PageStepper_PageStepper = (PageStepper);
// EXTERNAL MODULE: ./src/PageStepper/PageStepper.scss
var src_PageStepper_PageStepper = __webpack_require__(9625);
;// ./src/PageStepper/index.ts


/* harmony default export */ const src_PageStepper = (PageStepper_PageStepper);
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});